import CustomElement from "./CustomElement";
import { gsap } from "gsap";

const TOTAL_CANDIES = 256;

export default class CandyRain extends CustomElement {

	constructor() {

		super();

		this.wrapper = this.querySelector(".candy-rain-wrapper");
		this.container = this.querySelector(".candy-container");
		this.message = this.querySelector(".candy-message");

		this.templates = new Map();
		this.querySelectorAll(".candy-templates template").forEach((tpl) => {
			const handle = tpl.dataset.handle;
			if (!this.templates.has(handle)) this.templates.set(handle, []);
			this.templates.get(handle).push(tpl);
		});

		if (!window.candy) window.candy = this;
	}

	populateCandies(productCounts) {

		const counts = productCounts && Object.keys(productCounts).length
			? productCounts
			: Object.fromEntries([...this.templates.keys()].map((h) => [h, { quantity: 1 }]));

		const qtyOf = (info) => (typeof info === "number" ? info : info.quantity);
		const total = Object.values(counts).reduce((a, info) => a + qtyOf(info), 0);

		const candies = [];

		Object.entries(counts).forEach(([handle, info]) => {
			const qty = qtyOf(info);
			const image = typeof info === "object" ? info.image : null;
			const pool = this.templates.get(handle);
			const n = Math.round(TOTAL_CANDIES * (qty / total));

			for (let i = 0; i < n; i++) {
				if (pool?.length) {
					const tpl = pool[i % pool.length];
					candies.push(tpl.content.firstElementChild.cloneNode(true));
				} else if (image) {
					candies.push(this.buildCandyFromImage(image));
				}
			}
		});

		// Fisher-Yates shuffle so the rain is interleaved, not handle-grouped
		for (let i = candies.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[candies[i], candies[j]] = [candies[j], candies[i]];
		}

		this.container.replaceChildren(...candies);
		this.candies = this.container.querySelectorAll(".candy");
		window.Zero?.lazyLoad?.update();
	}

	buildCandyFromImage(imageUrl) {
		const div = document.createElement("div");
		div.className = "candy w-[100px] dk:w-[180px] h-0 pb-[100px] dk:pb-[180px] absolute transform -translate-x-1/2 -translate-y-1/2";
		div.innerHTML = `<img class="absolute inset-0 w-full h-full object-contain" src="${imageUrl}" alt="" />`;
		return div;
	}

	setAnimation() {

		this.timeline?.kill();
		this.timeline = gsap.timeline({ paused: true });

		this.timeline.set(this.wrapper, {
			pointerEvents: "all"
		});

		const candyHeight = this.candies[0].clientHeight;
		const fallStart = window.Zero.windowHeight + candyHeight;
		const fallEnd = window.Zero.windowHeight + candyHeight * 2;

		this.timeline.set(this.candies, {
			left: `random(0, ${window.Zero.windowWidth}, 20)`,
			"--tw-scale-x": `random(0.95, 1.05)`,
			"--tw-scale-y": `random(0.95, 1.05)`,
			"--tw-rotate": () => `${gsap.utils.random(0, 180)}deg`,
			"--tw-translate-y": `${-candyHeight}px`
		});

		this.timeline.fromTo(this.wrapper, {
			opacity: 0
		}, {
			opacity: 1,
			duration: 0.35
		});

		this.timeline.fromTo(this.message, {
			opacity: 0
		}, {
			opacity: 1,
			duration: 0.35
		});

		this.timeline.to(this.candies, {
			"--tw-translate-y": () => `${gsap.utils.random(fallStart, fallEnd)}px`,
			duration: 1,
			stagger: (1000 / this.candies.length) / 1000
		}, "-=0.2");

		this.timeline.fromTo(this.message, {
			opacity: 1
		}, {
			opacity: 0,
			duration: 0.35
		}, "-=0.45");
	}

	runAnimation({ callback = () => {}, setsImage = false, productCounts } = {}) {

		this.populateCandies(productCounts);

    console.log("[candy] counts =", productCounts);
    console.log("[candy] templates handles =", [...this.templates.keys()]);

		if (!this.candies.length) {
			callback();
			return;
		}

		if (setsImage) {
			let goalImageHTML = document.querySelector(".goal-picture").innerHTML;
			let imageContainer = this.querySelector(".image");

			imageContainer.innerHTML = goalImageHTML;
			window.Zero.lazyLoad.update();
		}

		this.setAnimation();
		this.timeline.eventCallback("onComplete", callback);
		this.timeline.play(0);
	}

	close() {

		this.wrapper.style.pointerEvents = "none";

		gsap.to(this.wrapper, {
			opacity: 0,
			duration: 0.35
		});
	}
}
